import styled from "styled-components";
import Search from "../../assets/icons/search.svg";

export const SearchContainer = styled.div`
  background-color: transparent;
  border-radius: 4px;
  display: flex;
  align-items: center;
  position: relative;
  border-radius: 35px;
  width: 90%;
  height: 42px;
  min-width: 400px;
  overflow: hidden;
  @media (max-width: 860px) {
    min-width: unset;
  }
`;

export const SearchInput = styled.input`
  background: none;
  border: none;
  width: 100%;
  height: 100%;
  outline: none;
  font-size: 1rem;
  padding: 0.3rem 1rem;
`;
export const SearchIconContainer = styled.div`
  width: 58px;
  display: grid;
  place-content: center;
  height: 42px;
`;
export const SearchIcon = styled.img.attrs({ src: Search })`
  color: black;
`;
export const XIcon = styled.img``;

//   .searchIcon {
//     margin-right: 1rem;
//     cursor: pointer;
//   }
//   .Xicon {
//     width: 12px;
//     margin-right: 1rem;
//     cursor: pointer;
//   }

//   .hide {
//     opacity: 0;
//     pointer-events: none;
//   }
//   .show {
//     opacity: 1;
//     pointer-events: all;
//   }
//   @media only screen and (max-width: 600px) {
//     .searchContainer {
//       position: absolute;
//       width: 100%;
//       right: 50%;
//       top: 0;
//       height: calc(105px - 2.5rem);
//       transition: right 400ms cubic-bezier(0.87, 0, 0.13, 1) 0s,
//         opacity 400ms cubic-bezier(0.87, 0, 0.13, 1);
//       opacity: 0;
//     }
//     .searchContainerOpened {
//       right: 0;
//       opacity: 1;
//     }
//     .searchIcon {
//       display: none;
//     }
//   }
